<template>
    <div class="animated fadeIn">
    <loader
     :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ permisos.area }} </strong>
          </div>
            <b-row>
              <b-col md="6" sm="12" v-for="(element, index) in permisos.subArea" :key="index">
                <b-card no-body>
                    <h4 slot="header">{{element.nombre}}</h4>
                    <b-list-group flush>
                        <b-list-group-item v-for="(item, index) in element.permisos" :key="index">
                          {{ item.numero }} - {{item.nombre}}
                        </b-list-group-item>
                    </b-list-group>
                    <b-card-footer class="text-right">
                      <b-button size="sm" variant="secondary" @click="agregarPermiso(element._id)">Agregar permiso</b-button>
                    </b-card-footer>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" class="text-left">
                <br><br>
                <b-button 
                  @click="regresar()"
                  size="sm" 
                  variant="secondary"
                  >
                  Regresar
                </b-button>
              </b-col>
              <b-col md="10" class="text-right">
                <br><br>
                <b-button 
                  @click="agregarSubarea()"
                  size="sm" 
                  variant="primary"
                  >
                  Agregar sub-área
                </b-button>
              </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>
    </div>
</template>

<script>

import axios from 'axios'
import Loader from '../Loader'
import swal from 'sweetalert2'
import { mapGetters } from "vuex";

export default {
  name: 'listadoPermisos',
  components:{
    Loader
  },  
  computed: {
      ...mapGetters([ "httpURL", "sessionToken","role"])
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      area: this.$route.params.area,
      permisos: {area:'',subArea:[]}
    }
  },
  created(){
      if( this.role =! 'administrador') this.$router.go(-1);
      this.enviando = true;
      axios.get(this.httpURL+'/permisos/'+this.area,{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.permisos = res.data.permisos;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
                  this.$router.go(-1);
              });
  },
  methods: {
    regresar(){
        this.$router.go(-1);
    },
    async agregarSubarea(){
      const {value: nombre } = await swal({
          title: '',
          text: 'Ingrese el nombre de la sub-área:',
          input: 'text',
          allowOutsideClick: true,
          showCancelButton: true,
          confirmButtonText: 'Agregar',
          cancelButtonText: 'Cancelar',
          inputValidator: (value) => {
              return new Promise((resolve) => {
                  resolve();
              })
          }
      });
      if( nombre ){
    
        this.enviando = true;
        swal.close();
        axios.post(this.httpURL+'/permisos/'+this.area+'/subarea',
              {nombre},
              {headers: {token:this.sessionToken}})
          .then(res => {
              this.enviando = false;
              //let subarea = {nombre:nombre,permiso:[]};
              this.permisos.subArea.push(res.data.subArea);
          })
          .catch(error => {
              //console.log(error);
              this.enviando = false;
              swal("Error",'No se pudo agregar la sub-área', "error");
          });
      }
    },
    async agregarPermiso(subarea){
      const {value: nombre } = await swal({
          title: '',
          text: 'Ingrese el nombre del permiso:',
          input: 'text',
          allowOutsideClick: true,
          showCancelButton: true,
          confirmButtonText: 'Agregar',
          cancelButtonText: 'Cancelar',
          inputValidator: (value) => {
              return new Promise((resolve) => {
                  resolve();
              })
          }
      });
      if( nombre ){
    
        this.enviando = true;
        swal.close();
        //console.log('area: '+this.area+' subarea: '+subarea);
        axios.post(this.httpURL+'/permisos/'+this.area+'/'+subarea,
              {nombre},
              {headers: {token:this.sessionToken}})
          .then(res => {
              for (let i = 0; i < this.permisos.subArea.length; i++) {
                  if (this.permisos.subArea[i]._id == subarea) {
                    this.permisos.subArea[i].permisos.push(res.data.permiso);
                    break;
                  }
              }
              this.enviando = false;
          })
          .catch(error => {
              //console.log(error);
              this.enviando = false;
              swal("Error",'Ocurrió un error al agregar el permiso', "error");
          });
      }
    }
  }
}
    
</script>